<div class="flex flex-col items-center gap-5">
  <h2 class="text-4xl ">Propose Changes</h2>
  <h4 class="text-lg text-gray-600 underline cursor-pointer" (click)="openDisclosureNotice()">Disclosure Notice</h4>
  <div class="flex flex-col justify-center gap-4">
    <div class="flex flex-col gap-5 items-center">
      <h3 class="text-xl font-bold">Move Funds From</h3>
      <div class="w-full flex flex-col md:flex-row md:gap-5 justify-center">
        <tandem-form-select
          class="w-full"
          [form]="formGroup"
          [label]="'Type'"
          [inputId]="'sourceType'"
          [controlName]="'sourceType'"
          [onFormReset]="formReset"
          [options]="typeOptions">
        </tandem-form-select>
        <tandem-form-select [form]="formGroup"
                            class="w-full"
                            [label]="'Category'"
                            [inputId]="'sourceCategory'"
                            [controlName]="'sourceCategory'"
                            [options]="sourceCategoryOptions"
                            ></tandem-form-select>
        <tandem-form-select
          class="w-full"
          [form]="formGroup"
          [label]="'Item'"
          [inputId]="'sourceItem'"
          [controlName]="'sourceItem'"
          [options]="sourceItemOptions"></tandem-form-select>
        <tandem-form-input
          class="w-full"
          inputType="number"
          [form]="formGroup"
          [label]="'Amount'"
          [inputId]="'amount'"
          [controlName]="'amount'"
          [placeholder]="'Amount'"
          [maskType]="'currency'"
          prefixText="$"></tandem-form-input>
      </div>
    </div>
    <div class="flex flex-col gap-5 items-center">
      <h3 class="text-xl font-bold">Move Funds To</h3>
      <div class="w-full flex flex-col md:flex-row md:gap-5 justify-center">
        <tandem-form-select
          class="w-full"
          [form]="formGroup"
          [label]="'Type'"
          [inputId]="'destinationType'"
          [controlName]="'destinationType'"
          [options]="typeOptions"></tandem-form-select>
        <tandem-form-select [form]="formGroup"
                            class="w-full"
                            [label]="'Category'"
                            [inputId]="'destinationCategory'"
                            [controlName]="'destinationCategory'"
                            [options]="destinationCategoryOptions"></tandem-form-select>
        <tandem-form-select
          class="w-full"
          [form]="formGroup"
          [label]="'Item'"
          [inputId]="'destinationItem'"
          [controlName]="'destinationItem'"
          [options]="destinationItemOptions"></tandem-form-select>
      </div>
    </div>
  </div>
  <tandem-button theme="solid" [onClick]="onSubmit.bind(this)" [disabled]="formGroup.invalid">Submit</tandem-button>
</div>


